import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-234c7f2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "countdown-timer-container" }
const _hoisted_2 = { id: "countdown-information-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "icon-container",
  class: "d-flex align-items-center justify-content-center"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-clock" })
], -1))
const _hoisted_4 = {
  id: "text-container",
  class: "d-flex align-items-center justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString(_ctx.elapsedTimeConverted), 1),
          _createTextVNode(" / " + _toDisplayString(_ctx.totalConverted), 1)
        ])
      ])
    ])
  ]))
}